import { Typography } from "@mui/material";
import { styled as muiStyled } from "@mui/system";
import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 1070px;
    margin: 0rem auto;
    border-radius: 20px;
    padding: 1rem 0;
`;

const COLORS = {
    cardBg: "#0A1A3C",
    cardHover: "#122855",
    arrowBg: "#DDDDDD",
    arrowHover: "#EEE",
    arrowColor: "#9F9999",
};

export const RelativeContainer = styled.div`
    position: relative;

    @media (min-width: 1200px) {
        max-width: 1045px;
        margin: 0 auto;
    }
`;

export const CarouselArea = styled.div`
    overflow: hidden;
    width: ${({ width }) => `${width}px`};
    margin: 0 auto;
    padding: 16px 15px 0px 0px;
`;

export const ArrowButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    background-color: ${COLORS.arrowBg};
    color: ${COLORS.arrowColor};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: ${COLORS.arrowHover};
    }
`;

export const ArrowButtonLeft = styled(ArrowButton)`
    left: 0;

    @media (min-width: 1200px) {
        left: -48px;
    }
`;

export const ArrowButtonRight = styled(ArrowButton)`
    right: 0;

    @media (min-width: 1200px) {
        right: -48px;
    }
`;

export const CarouselContent = styled.div`
    display: flex;
    gap: ${({ gap }) => `${gap}px`};
    transform: translateX(-${props => props.translate}px);
    transition: transform 0.3s ease-in-out;
    will-change: transform;
`;
export const Title = muiStyled(Typography)(() => ({
  fontWeight: 600,
  color: "#0095FE",
  fontSize: "20px",
  margin: "0 auto 1rem",
  maxWidth: "909.5px",

  '@media (max-width: 768px)': {
    margin: "0 auto 1rem 16px",
    maxWidth: "100%",
  },

  '@media (min-width: 768px) and (max-width: 1024px)': {
    width: "678px",
  },

  '@media (min-width: 1200px)': {
    maxWidth: "1045px",
  },
}));

export const CouponContainer = styled.div`
    display: flex;
    gap: 20px;
    justify-content: center;
`

export const CouponBox = styled.div`
    position: relative;
    box-sizing: border-box; /* 🔥 essencial */
    border: 1px solid #363636; 
    padding: 15px;  
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 13px;
    width: ${({ width }) => `${width}px`};
    flex-shrink: 0;
    overflow: visible;

    @media(max-width: 768px){
        padding: 10px;
        scroll-snap-align: start;
        flex-shrink: 0;
        width: ${({ width }) => `${width}px`};

    }
`;

export const ContainerImageDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const CouponImage = styled.img`
    width: 80px;
`

export const CouponDescription = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #363636;
  text-align: center;

  display: -webkit-box;
  -webkit-line-clamp: 3;        /* 👈 número de linhas */
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CouponExpiration = styled.div`
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 2px;
`


export const CouponCashback = styled.div`
    font-weight: 900;
    color: #0095FE;
    font-size: 12px;

    @media(max-width: 768px){
        font-size: 11px;
    }
`

export const CouponButton = styled.div`
  align-items: center;
  justify-content: center;
  display: flex ;
  z-index: 1;
  width: 128px;
  height: 45px;
  gap: 5px;
  padding: 0px 5px ;

  background-color: #0095FE;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;

  font-weight: 600;
  border-radius: 16px;

  clip-path: polygon(
    0 0,
    calc(100% - 22px) 0,
    100% 22px,
    100% 100%,
    0 100%
  );

    @media(max-width: 768px){
        padding: 8px 5px;
        font-size: 12px;
        width: auto;
        height: auto;
    }
`;

export const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border: 2px dashed #0095FE;
    border-radius: 16px;

    opacity: 0.4;
    z-index: 0;
  }
`;

export const LockBadge = styled.div`
    cursor: pointer;
    width: 34px;
    height: 34px;
    border: 2px dashed white;
    border-radius: 50%;
    background-color: #0095FE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    z-index: 10;

    @media(max-width: 768px){
        left: ${({ isCouponButton }) => (isCouponButton ? '60%' : '50%')};
        width: 25px;
        height: 25px;
    }
`;
export const Selo = styled.img`
  position: absolute;
  top: -20px;
  right: -20px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const CarouselAreaMobile = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding: 16px 0 16px 16px; /* 👈 padding ESQUERDO AQUI */
  scroll-padding-left: 16px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CarouselContentMobile = styled.div`
  display: flex;
  gap: 16px;
`;






